import { useSelector, useDispatch } from 'react-redux';
import { useState } from 'react';
import AsyncComponentContext from 'page-editor-ui/context/AsyncComponentContext';
import ThemeMofoFields from 'theme-previewer-lib/components/ThemeMofoFields';
import AsyncComponentsContext from 'page-editor-ui/context/AsyncComponentContext';
import { makeAsyncComponent } from 'theme-previewer-lib/utils/makeAsyncUtils';
import UniversalEditorAppContainer from 'theme-previewer-lib/containers/UniversalEditorAppContainer';
import { UNIVERSAL_THEME_EDITING_APPS } from 'theme-previewer-lib/constants';
import { getTemplatePath } from 'ContentEditorUI/redux/selectors/baseContentModelSelectors';

// @ts-expect-error Untyped module
import { save } from 'page-editor-ui/redux/actions/pageSaveActions';
import { fetchPageCssAssets } from 'ContentEditorUI/redux/actions/contentAssetsActions';

// import { setHasThemeBufferToPublish } from 'ContentEditorUI/redux/actions/themeActions';
import { jsx as _jsx } from "react/jsx-runtime";
const AUTOSAVE_DEBOUNCE_MS = 2000;
const AsyncEPDependentsPanel = makeAsyncComponent(() => import( /* webpackChunkName: 'EPDependentsPanel' */'theme-previewer-lib/components/EPDependentsPanel'));
const ThemeEditorContainer = () => {
  const AsyncComponents = {
    ThemeMofoFields,
    EPDependentsPanel: AsyncEPDependentsPanel
  };
  const dispatch = useDispatch();
  const templatePath = useSelector(getTemplatePath);
  const [isUniversalThemeSavedAndApplied, setIsUniversalThemeSavedAndApplied] = useState(false);
  const handleSaveThemeSettingsBuffer = () => {
    //TODO look into replacing this with debounce
    setTimeout(() => {
      //TODO uncomment once CEUI PR is merged
      // dispatch(setHasThemeBufferToPublish(true));
      dispatch(save({
        isUniversalThemeSaving: true
      }));
      //allow some time for buffer to be saved before refetching css assets
      dispatch(fetchPageCssAssets());
      setIsUniversalThemeSavedAndApplied(true);
    }, AUTOSAVE_DEBOUNCE_MS);
  };
  const reloadIframePreview = () => {
    const bus = window.hubspot.ContentEditorUI.eventBus;
    bus.trigger('preview:refresh');
  };
  const handleSetIsUniversalThemeSavedAndApplied = value => {
    setIsUniversalThemeSavedAndApplied(value);
  };
  return /*#__PURE__*/_jsx(AsyncComponentContext.Provider, {
    value: AsyncComponents,
    children: /*#__PURE__*/_jsx(UniversalEditorAppContainer, {
      AsyncComponentContext: AsyncComponentsContext,
      fromAppName: UNIVERSAL_THEME_EDITING_APPS.PAGE_EDITOR,
      businessUnitId: "0",
      templatePath: templatePath,
      handleSaveThemeSettingsBuffer: handleSaveThemeSettingsBuffer
      // @ts-expect-error remove once theme previewer PR is merged
      ,
      reloadIframePreview: reloadIframePreview,
      handleSetIsUniversalThemeSavedAndApplied: handleSetIsUniversalThemeSavedAndApplied,
      isUniversalThemeSavedAndApplied: isUniversalThemeSavedAndApplied
    })
  });
};
export default ThemeEditorContainer;